import { ShapeRenderer, type ShapeSpec } from "./ShapeRenderer";

function BlockGrid({ cells, size = 3 }: { cells: number[]; size?: number }) {
  const filled = new Set(cells);
  return (
    <div
      className="grid aspect-square w-32 overflow-hidden rounded-md border border-cyan-100/70 bg-cyan-100/70 p-[2px]"
      style={{ gridTemplateColumns: `repeat(${size}, minmax(0, 1fr))`, gridTemplateRows: `repeat(${size}, minmax(0, 1fr))`, gap: 2 }}
    >
      {Array.from({ length: size * size }, (_, cell) => (
        <span key={cell} className="flex min-h-0 min-w-0 items-center justify-center bg-slate-950/90">
          {filled.has(cell) ? <span className="block h-full w-full bg-cyan-200 shadow-[0_0_12px_rgb(103_232_249_/_0.35)]" /> : null}
        </span>
      ))}
    </div>
  );
}

export function SpatialRenderer({ visualSpec }: { visualSpec: Record<string, unknown> }) {
  if (visualSpec.kind === "blockRotation") {
    const size = Number(visualSpec.gridSize ?? 3);
    const initialCells = Array.isArray(visualSpec.initialCells) ? visualSpec.initialCells.map(Number) : [];
    const instruction = typeof visualSpec.instruction === "string" ? visualSpec.instruction : "Περιστροφή 90° δεξιόστροφα";

    return (
      <div className="grid w-full gap-3 rounded-lg border border-white/10 bg-slate-950/35 p-4 sm:grid-cols-[1fr_auto_1fr]">
        <div className="flex min-h-40 flex-col items-center justify-center gap-3 rounded-lg bg-white/[0.045]">
          <span className="text-xs font-semibold text-slate-400">Αρχικό</span>
          <BlockGrid cells={initialCells} size={size} />
        </div>
        <div className="flex items-center justify-center px-2 text-center text-sm font-bold text-cyan-100 sm:min-w-32">{instruction}</div>
        <div className="flex min-h-40 flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-cyan-200/35 bg-cyan-200/5">
          <span className="text-xs font-semibold text-slate-400">Επίλεξε αποτέλεσμα</span>
          <span className="text-3xl font-bold text-cyan-100">?</span>
        </div>
      </div>
    );
  }

  const base = (visualSpec.base ?? { shape: "arrow", color: "cyan" }) as ShapeSpec;
  const targetRotation = Number(visualSpec.targetRotation ?? 90);
  return (
    <div className="grid w-full gap-3 rounded-lg border border-white/10 bg-slate-950/35 p-4 sm:grid-cols-2">
      <div className="flex min-h-32 flex-col items-center justify-center gap-3 rounded-lg bg-white/[0.045]">
        <span className="text-xs font-semibold text-slate-400">Αρχικό</span>
        <ShapeRenderer spec={{ ...base, size: "lg" }} />
      </div>
      <div className="flex min-h-32 flex-col items-center justify-center gap-3 rounded-lg bg-white/[0.045]">
        <span className="text-xs font-semibold text-slate-400">Περιστροφή {targetRotation}°</span>
        <ShapeRenderer spec={{ shape: "arrow", color: "violet", rotation: targetRotation, size: "lg" }} />
      </div>
    </div>
  );
}
